import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";
import ProductDialog from "@/components/ProductDialog";

function priceFrom(sizes) {
  if (!sizes || sizes.length === 0) return "—";
  const min = Math.min(...sizes.map((s) => s.price));
  return `от ${min} лв`;
}

export default function ProductGrid() {
  const [products, setProducts] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/products").then((res) => setProducts(res.data)).catch(() => {});
  }, []);

  return (
    <section id="collection" className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32" data-testid="collection">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-16 gap-6">
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-clay font-medium mb-5">Колекцията</p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink">Изберете своите цветя</h2>
        </div>
        <p className="text-stone font-light max-w-xs">
          Всеки модел е наличен в различни размери. Докоснете, за да изберете.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
        {products.map((p, i) => (
          <motion.button
            key={p.id}
            onClick={() => setActive(p)}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: (i % 3) * 0.08 }}
            className={`group text-left ${i % 3 === 1 ? "lg:mt-16" : ""}`}
            data-testid={`product-card-${p.id}`}
          >
            <div className="overflow-hidden rounded-xl bg-sand aspect-[3/4] mb-5">
              <img
                src={p.images?.[0]}
                alt={p.name}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="flex items-baseline justify-between gap-4">
              <h3 className="font-serif text-2xl text-ink group-hover:text-clay transition-colors duration-300">
                {p.name}
              </h3>
              <span className="text-sm text-stone whitespace-nowrap">{priceFrom(p.sizes)}</span>
            </div>
            <p className="text-xs uppercase tracking-[0.15em] text-stone/70 mt-2">{p.category}</p>
          </motion.button>
        ))}
      </div>

      <ProductDialog product={active} onClose={() => setActive(null)} />
    </section>
  );
}
